var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"image-wrap"},[_c('img',{class:['offer-tag', {special: _vm.isSpecial}],attrs:{"src":_vm.specialSrc}}),_c('img',{staticClass:"img-fluid",attrs:{"src":_vm.imageSrc,"alt":""}}),_c('span',[_vm._v(_vm._s(_vm.msg))])])}
var staticRenderFns = []

export { render, staticRenderFns }